import type { CSSProperties } from 'react'
import { StripeTag } from '@/design-system'

export function LinkReadyCard({ style }: { style?: CSSProperties }) {
  return (
    <div
      aria-hidden
      style={{
        background: 'var(--sky)',
        border: 'var(--border-w) solid var(--ink)',
        boxShadow: 'var(--shadow-lg)',
        padding: 16,
        transform: 'rotate(2.5deg)',
        ...style
      }}>
      <StripeTag>Link ready</StripeTag>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 14, fontWeight: 700, marginTop: 8 }}>
        snaptransfer.app/k7-mauve-otter
      </div>
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 11,
          opacity: 0.7,
          marginTop: 4,
          letterSpacing: '0.08em'
        }}>
        EXPIRES IN 7 DAYS · PASSWORD ON
      </div>
    </div>
  )
}
